import React from 'react';
import { WalletIcon, ClockIcon, MoonIcon, HeartCrackIcon, RotateCcwIcon } from 'lucide-react';
import { trackFbEvent } from '../utils/fbpixel';
const costs = [{
  icon: WalletIcon,
  title: 'La plata que ya tiraste',
  desc: 'Óvulos, cremas y turnos privados que aliviaron unos días… y después volvió todo.'
}, {
  icon: ClockIcon,
  title: 'Meses (o años) perdidos',
  desc: 'Probando, googleando y esperando que “esta vez sí” funcione, sin una guía clara.'
}, {
  icon: MoonIcon,
  title: 'Noches sin dormir',
  desc: 'El ardor y la picazón que no te dejan descansar ni pensar en otra cosa.'
}, {
  icon: HeartCrackIcon,
  title: 'Tu intimidad y tu ánimo',
  desc: 'Evitar a tu pareja, sentirte incómoda en tu propio cuerpo y cargar con eso en silencio.'
}, {
  icon: RotateCcwIcon,
  title: 'El ciclo que no se corta',
  desc: 'Mejorás, recaés, volvés a empezar. Y cada recaída te convence de que “es así para siempre”.'
}];
export function CostOfInaction() {
  return <section className="w-full bg-brand-violet px-5 py-16" data-id="element-40">
      <div className="max-w-lg mx-auto" data-id="element-41">
        <div className="text-center mb-10" data-id="element-42">
          <h2 className="text-[28px] sm:text-[34px] font-bold text-white leading-tight" data-id="element-43">
            ¿Cuánto cuesta no tenerlo?
          </h2>
          <p className="text-white/80 text-[16px] leading-relaxed mt-3 max-w-md mx-auto" data-id="element-44">
            No comprarlo también tiene un precio. Solo que lo pagás en cuotas,
            todos los meses, sin que nunca se termine.
          </p>
        </div>

        <div className="flex flex-col gap-3 mb-9" data-id="element-45">
          {costs.map(({
          icon: Icon,
          title,
          desc
        }) => <div key={title} className="bg-white/10 backdrop-blur-sm rounded-2xl p-4 flex items-start gap-3" data-id="element-46">
              <div className="bg-white/15 rounded-xl p-2 flex-shrink-0" data-id="element-47">
                <Icon className="w-5 h-5 text-white" data-id="element-48" />
              </div>
              <div data-id="element-49">
                <p className="text-white font-bold text-[15px] leading-tight" data-id="element-50">
                  {title}
                </p>
                <p className="text-white/75 text-[13px] leading-snug mt-0.5" data-id="element-51">
                  {desc}
                </p>
              </div>
            </div>)}
        </div>

        <div className="bg-white rounded-[20px] p-6 text-center mb-7" data-id="element-52">
          <p className="text-brand-text text-[16px] leading-relaxed" data-id="element-53">
            Todo eso, sumado, cuesta muchísimo más que{' '}
            <strong className="text-brand-violet" data-id="element-54">$19.990 una sola vez</strong>.
            La diferencia es que el Método pH-ZERO sí te saca del ciclo —{' '}
            <strong className="text-brand-magenta" data-id="element-55">para no volver</strong>.
          </p>
        </div>

        <a href="#compra" onClick={() => trackFbEvent('InitiateCheckout', {
        content_name: 'Cost Of Inaction CTA',
        value: 19990,
        currency: 'ARS'
      })} className="w-full block bg-brand-magenta hover:brightness-110 text-white font-bold text-[16px] rounded-xl py-4 text-center transition-all shadow-[0_4px_24px_rgba(212,0,110,0.25)]" data-id="element-56">
          🔓 QUIERO CORTAR EL CICLO HOY
        </a>
      </div>
    </section>;
}